import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

import { ReportTableBaseProps } from '../../report.types';
import ExportButton from '../ExportButton';
import PlaceholderBase from '../PlaceholderBase';
import { ReportSummaryWrapper } from '../ReportSummary';
import TopButtonPortalWrapper from '../TopButtonPortalWrapper';

interface Props extends ReportTableBaseProps {}

const EmployeeDemographicsReportSummary: React.FC<Props> = ({ isPreviewMode }) => {
  return (
    <TopButtonPortalWrapper
      isPreviewMode={isPreviewMode}
      infoNode={null}
      buttonNode={
        <Box direction="row">
          <ExportButton onClick={() => {}} disabled={true} text="Download Summary (CSV)" />
        </Box>
      }
    >
      <ReportSummaryWrapper isPreviewMode={isPreviewMode}>
        <PlaceholderBase>
          <Text weight="bold">Summary is not available for this report</Text>
        </PlaceholderBase>
      </ReportSummaryWrapper>
    </TopButtonPortalWrapper>
  );
};

export default EmployeeDemographicsReportSummary;
